import React from "react";
import logoZippy from "@/assets/logo-zippy.png";

/**
 * FixyDany brand mark — ZIPPY the FixyBee.
 * PNG with transparent background.
 */
export default function FixyBeeMark({ size = 40, className = "" }) {
  return (
    <img
      src={logoZippy}
      alt="FixyDany"
      width={size}
      height={size}
      className={className}
      style={{ display: "inline-block", objectFit: "contain" }}
      draggable={false}
    />
  );
}
